import {
    BaseTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/base-transition-model';
import { IAnimationSetting, IWarpTransition } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { TransitionTarget, TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { TransitionConfig } from '@src/slide/domain/ui-model/element-modeles/transition/config';
import { InOutDirection } from '@src/slide/domain/ui-model/element-modeles/transition/direction/in-out-direction';
import { InOutDirectionType } from '@src/slide/domain/ui-model/element-modeles/transition/direction/constants';

export class WarpTransitionModel extends BaseTransitionModel<IWarpTransition> implements IWarpTransition {
    public type = TransitionType.WARP;
    public direction: InOutDirection;

    public getAnimationSetting(isSwitchForward): IAnimationSetting[] {
        const direction = this.direction.getDirectionType(isSwitchForward);
        if (direction === InOutDirectionType.IN) {
            return [{
                fromStyle: {
                    ...TransitionConfig.SCALE_NORMAL,
                    ...TransitionConfig.OPACITY_SHOW,
                },
                toStyle: {
                    ...TransitionConfig.OPACITY_HIDE,
                    ...TransitionConfig.SCALE_LARGE,
                },
                target: TransitionTarget.EXIT,
            }, {
                fromStyle: {
                    ...TransitionConfig.SCALE_SMALL,
                    ...TransitionConfig.OPACITY_HIDE,
                },
                toStyle: {
                    ...TransitionConfig.OPACITY_SHOW,
                    ...TransitionConfig.SCALE_NORMAL,
                },
                target: TransitionTarget.ENTER,
            }];
        }
        return [{
            fromStyle: {
                ...TransitionConfig.SCALE_NORMAL,
                ...TransitionConfig.OPACITY_SHOW,
            },
            toStyle: {
                ...TransitionConfig.OPACITY_HIDE,
                ...TransitionConfig.SCALE_SMALL,
            },
            target: TransitionTarget.EXIT,
        }, {
            fromStyle: {
                ...TransitionConfig.SCALE_LARGE,
                ...TransitionConfig.OPACITY_HIDE,
            },
            toStyle: {
                ...TransitionConfig.OPACITY_SHOW,
                ...TransitionConfig.SCALE_NORMAL,
            },
            target: TransitionTarget.ENTER,
        }];
    }
}
